import React, { Component, Fragment } from "react"
import { includes, uniq, isEmpty, isNil, head, find } from "lodash"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import { connect } from "react-redux"
import styles from "./styles"
import MainAppBar from "../../components/MainAppBar"
import { Button, Typography, Popover, Fab, Box } from "@material-ui/core"
import {
  toggleShootDialog,
  toggleEditShootDialog,
  setEditShoot,
  shootsByCrew,
  getCalenderShoots,
  clearShoots,
  getShootbyId,
} from "../../actions/shoots"
import {
  saveDefaultFilters,
  getDefaultFilters,
  removeDefaultFilters,
} from "../../actions/users"
import { getUsers, getRoles } from "../../actions/misc"
import { getShoots } from "../../actions/shoots"
import TabBar from "../../components/TabBar"
import FilterDialog, { filterOptions } from "./filterDialog"
import FilterBar from "./filterBar"
import CalendarHeaderToolbar from "./calendarToolbar"
import CreatorFilterDialog from "./creatorFilterDialog"
import FilterPreferencesDialog from "./filterPreferencesDialog"
import CustomActionBar from "./customActionBar"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import listPlugin from "@fullcalendar/list"
import green from "@material-ui/core/colors/green"
import CircularProgress from "@material-ui/core/CircularProgress"
import Hidden from "@material-ui/core/Hidden"
import { sortOptions } from "./sortBy"
import { dateOptions } from "./dateFilter"
import $ from "jquery"
import "@fullcalendar/list/main.css"
import "@fullcalendar/daygrid/main.css"
import moment from "moment"
import { convertToAbbr } from "../../lib/states.js"
import EditShootDialog from "../../components/EditShootDialog/index"
import DuplicateConfirmDialog from "../../components/DuplicateShootConfirmDialog/index"
import Image from "../../assets/images/login_bg.jpg"
import { withRouter } from "react-router"
import { getCrew } from "../../actions/crew"
import Avatar from "@material-ui/core/Avatar"
import AddIcon from "@material-ui/icons/Add"
import { openSnackBar } from "../../actions/snack-bar"
import LoadingOverlay from "react-loading-overlay"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import { getCurrentHost } from "../../utils/getHost"

function addDays(date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

var isDate = function(date) {
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date))
}
// CHECK FOR THE MOBILE VIEW
const isMobile = window.innerWidth < 600

const shootsPerPage = 50

const defaultState = {
  searchKey: false,
  search: "",
  sort: null,
  creatorFilters: [],
  filters: [],
  showDialog: false,
  creatorsAnd: false,
  and: false,
  dateFilter: null,
  startDate: null,
  endDate: null,
  creatorFilter: null,
  showCreatorFilterDialog: false,
  showFilterPreferencesDialog: false,
  popover: {
    func: () => "",
    anchor: null,
  },
  crewShoots: [],
  isCalendarView: false,
  isListView: true,
  eventPopoverEl: null,
  eventPopoverShoot: null,
  currentPage: 1,
  flag: 1,
  sort_shoots: false,
  height: null,
  eventPopoverPosition: {
    top: 0,
    left: 0,
  },
  dateSetStrDate: null,
  dateSetEndDate: null,
  minDateSetStrTime: null,
  maxDateSetEndTime: null,
  searchTimeout: null,
  isLoading: true,
  defaultFiltersSwitch: false,
  toggleFilterSwitch: true,
  dateShowTitle: "",
  dateOptions: [
    {
      id: 1,
      name: "Week",
    },
    {
      id: 2,
      name: "Day",
    },
    {
      id: 3,
      name: "Month",
    },
  ],
  defaultDateOption: {
    id: 1,
    name: "Week",
  },
  collapsedEventId: null,
}

class Shoots extends Component {
  render() {
    return (
      <Fragment>
        {/* {getCurrentHost() === "crewmama" ? <CrewMamaAppBarComponent history={this.props.history} /> : <Fragment>
            <MainAppBar />
            <TabBar history={this.props.history} />
          </Fragment>} */}
        <CrewMamaAppBarComponent history={this.props.history} />
        <iframe
          src="https://new-site.crewmama.com/shoots"
          style={{ height: "100vh", width: "100vw" }}
          title="Iframe Example"
          allow="clipboard-read; clipboard-write"
        />
        {/* <iframe
          src="https://new-site.crewmama.com/shoots"
          style={{ height: "100vh", width: "100vw" }}
          title="Iframe Example"
          allow="clipboard-read; clipboard-write"
        /> */}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    users: state.misc.users,
    roles: state.misc.roles,
    shoots: state.shoots.shoots,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    companies: state.companies,
    crew: state.crew,
    shootsLength: state.shoots.shootsLength,
    shoot: state.shoots.editShoot,
    editShootDialogOpen: state.shoots.editShootDialogOpen,
    confirmDuplicateShootDialogueOpen:
      state.shoots.confirmDuplicateShootDialogueOpen,
    searchedShoot: state.misc.equipment,
    defaultFilters: state.users.userDefaultFilters,
    recallGetShoots: state.shoots.recallGetShoots,
  }
}

export default withRouter(
  compose(
    connect(mapStateToProps),
    withStyles(styles, { withTheme: true })
  )(Shoots)
)
